<template>
    <div class="wrapper">
        <div class="main main-raised">
            <div class="section section-components pt-0">
                <a name="features"></a>
                <div class="section section-features-3">
                    <div class="container">
                        <div class="md-layout">
                            <div class="md-layout-item md-size-50 md-small-size-100 mx-auto">
                                <div class="image-container">
                                    <img
                                            class="components-macbook"
                                            :src="sectionComponents.img1"
                                            alt=""
                                    >
<!--                                    <img-->
<!--                                            class="table-img"-->
<!--                                            :src="sectionComponents.img2"-->
<!--                                            alt=""-->
<!--                                    >-->
<!--                                    <img-->
<!--                                            class="share-btn-img"-->
<!--                                            :src="sectionComponents.img3"-->
<!--                                            alt=""-->
<!--                                    >-->
<!--                                    <img-->
<!--                                            class="coloured-card-btn-img"-->
<!--                                            :src="sectionComponents.img4"-->
<!--                                            alt=""-->
<!--                                    >-->
<!--                                    <img-->
<!--                                            class="coloured-card-img"-->
<!--                                            :src="sectionComponents.img5"-->
<!--                                            alt=""-->
<!--                                    >-->
<!--                                    <img-->
<!--                                            class="social-img"-->
<!--                                            :src="sectionComponents.img6"-->
<!--                                            alt=""-->
<!--                                    >-->
<!--                                    <img-->
<!--                                            class="pin-btn-img"-->
<!--                                            :src="sectionComponents.img7"-->
<!--                                            alt=""-->
<!--                                    >-->
                                </div>
                            </div>
                        </div>
                    </div>
                    <a name="testimonials"></a>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

  import SecondBlock from '@/components/Custom/SecondBlock.vue';
  import Mixins from "@/plugins/basicMixins";
  import BlockPolza from "@/components/Custom/BlockPolza";
  import BlockFeatures from "@/components/Custom/BlockFeatures";
  import BlockComments from "@/components/Custom/BlockComments";
  import BlockPrice from "@/components/Custom/BlockPrice";
  import BlockContact from "@/components/Custom/BlockContact";
  import BlockSupport from "@/components/Custom/BlockSupport";
  import BlockMain from "@/components/Custom/BlockMain";


  export default {
    components: {
      // BlockFeatures,
    },
    mixins: [Mixins.HeaderImage],
    bodyClass: "presentation-page",
    props: {
    },
    data() {
      return {
        // image: require("@/assets/img/vue-mk-header.jpg"),
        // leafShow: false,
        // iphone: require("@/assets/img/sections/iphone.png"),
        // iphone2: require("@/assets/img/sections/iphone2.png"),
        // image: require("@/assets/img/bg9.jpg"),
        // sectionComponents: {
          img1: require("@/assets/img/sections/iphone.jpg"),
        //   img2: require("@/assets/img/sections/54fz.png"),
        //   img3: require("@/assets/img/section-components/share-btn.jpg"),
        //   img4: require("@/assets/img/section-components/coloured-card-with-btn.jpg"),
        //   img5: require("@/assets/img/section-components/coloured-card.jpg"),
        //   img6: require("@/assets/img/sections/atol.png"),
        //   img7: require("@/assets/img/section-components/pin-btn.jpg")
        }
      },

    mounted() {
      this.leafActive();
      window.addEventListener("resize", this.leafActive);
      document.addEventListener("scroll", this.scrollListener);
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.leafActive);
      document.removeEventListener("scroll", this.scrollListener);
    },
    methods: {
      leafActive() {
        if (window.innerWidth < 768) {
          this.leafShow = false;
        } else {
          this.leafShow = true;
        }
      }
    }
  };
</script>

<style lang="scss"></style>
